<template>
  <div id="productsMassEdit">
    <a-col :span="20" class="steps"> </a-col>
    <a-col :span="12">
      <div
        v-if="tickets.length == 0"
        id="drop"
        @drop="handleDrop"
        @dragover="handleDragover"
        @dragenter="handleDragover"
      >
        Déposer le fichier Excel ici (XLS / XLSX)
        <br />
        Exemple à respecter
        <a
          target="_blank"
          href="https://nextcloud.store.tribaliste.com/s/qBJEqf8EMbHoXc8"
          >ici</a
        >
      </div>
      <div v-else>
        <div v-if="waitServer">
          <a-progress
            v-if="waitServer"
            status="active"
            type="circle"
            :percent="waitPercent"
          />
        </div>
        <div v-else>
          <h2>Instructions</h2>
          <p>
            <a-icon
              type="check-circle"
              theme="twoTone"
              two-tone-color="#52c41a"
            />
            - Upload
          </p>
          <p>
            <a-icon
              type="check-circle"
              theme="twoTone"
              two-tone-color="#52c41a"
              v-if="this.uploadProductsReady == tickets.length - 1"
            />
            <a-icon
              type="exclamation-circle"
              theme="twoTone"
              two-tone-color="#FF8C00"
              v-else-if="waitActual == waitMax"
            />
            <a-icon v-else slot="icon" type="loading" />
            - Produits pret à uploadé {{ this.uploadProductsReady }} /
            {{ tickets.length - 1 }}
          </p>
          <a-button
            v-if="this.uploadProductsReady > 0"
            type="danger"
            @click="massUpload"
          >
            Envoyer au serveur !
          </a-button>
        </div>
      </div>
    </a-col>
    <a-col :span="24"> </a-col>
    <a-col :span="24" class="tableData">
      <!-- <a-table
        :row-selection="rowSelection"
        :columns="columns"
        :data-source="tickets"
        :rowKey="rowKey"
        :pagination="false"
        :rowClassName="tableRowClassName"
      >
      </a-table> -->
      <a-list item-layout="vertical" size="large" :data-source="uploadProducts">
        <!-- <div slot="footer"><b>ant design vue</b> footer part</div> -->
        <a-list-item
          slot="renderItem"
          key="item.reference['_']"
          slot-scope="item"
        >
          <template v-for="type in item.checkA" slot="actions">
            <span :key="type" v-if="type[0] != 'featuresResfused'">
              <a-icon
                v-if="type[1] == true"
                slot="icon"
                type="check-circle"
                theme="twoTone"
                two-tone-color="#52c41a"
              />
              <a-icon
                v-else-if="type[1] == 'wait'"
                slot="icon"
                type="loading"
                color="orange"
              />
              <a-icon
                v-else-if="type[1] == 'uploaded'"
                slot="icon"
                type="upload"
                color="#52c41a"
              />
              <a-icon
                v-else
                slot="icon"
                type="close-circle"
                theme="twoTone"
                two-tone-color="#FF0000"
              />
              <div v-if="type[0] == 'features'">
                <a-tooltip>
                  <template slot="title">
                    {{ item.check.featuresResfused }}
                  </template>
                  {{ type[0] | capitalize }}
                </a-tooltip>
              </div>
              <div v-else>
                {{ type[0] | capitalize }}
              </div>
            </span>
          </template>
          <img
            slot="extra"
            height="45"
            alt="logo"
            v-if="item.check['photos'] == 'wait'"
            src="data:image/svg+xml;base64,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"
          />
          <img
            slot="extra"
            height="150"
            alt="logo"
            v-else-if="item.check['photos']"
            :src="'data:image/jpeg;base64,' + item.step1.cat"
          />
          <img
            slot="extra"
            height="80"
            alt="logo"
            v-else
            src="data:image/png;base64,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"
          />
          <a-list-item-meta
            :description="item.description_short.language[0]['_']"
          >
            <h4 slot="title">
              {{ item.checkA[0][1] }} - {{ item.name.language[0]["_"] }}
            </h4>
            <a-avatar
              slot="avatar"
              :size="100"
              :style="{
                backgroundColor: item.checkA[0][1] == false ? 'red' : 'green',
              }"
              >{{ item.reference["_"] }}</a-avatar
            >
          </a-list-item-meta>
          {{ item.content }}
        </a-list-item>
      </a-list>
    </a-col>
  </div>
</template>

<script>
// @ts-nocheck
function get_header_row(sheet) {
  var headers = [],
    range = window.XLSX.utils.decode_range(sheet["!ref"]);
  var C,
    R = range.s.r; /* start in the first row */
  for (C = range.s.c; C <= range.e.c; ++C) {
    /* walk every column in the range */
    var cell =
      sheet[
        window.XLSX.utils.encode_cell({ c: C, r: R })
      ]; /* find the cell in the first row */
    var hdr = "UNKNOWN " + C; // <-- replace with your desired default
    if (cell && cell.t) hdr = window.XLSX.utils.format_cell(cell);
    headers.push(hdr);
  }
  return headers;
}
function fixdata(data) {
  var o = "",
    l = 0,
    w = 10240;
  for (; l < data.byteLength / w; ++l)
    o += String.fromCharCode.apply(
      null,
      new Uint8Array(data.slice(l * w, l * w + w))
    );
  o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
  return o;
}
import { mapState } from "vuex";
import _, { isNumber } from "lodash";
import axios from "axios";
export default {
  name: "productsMassEdit",
  data() {
    return {
      tickets: [],
      headers: ["Test header"],
      mapper: [],
      mapperReady: null,
      selectReady: null,
      selectedValue: null,
      waitServer: null,
      waitMax: null,
      waitActual: 0,
      waitUpload: 0,
      indexMappValue: ["id", "reference"],
    };
  },
  components: {},
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  computed: {
    ...mapState([
      "products",
      "productStructure",
      "supplierStructure",
      "categoriesList",
      "featuresList",
      "suppliers",
      "languageDetail",
      "userToken",
      "loading",
    ]),
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedValue = selectedRows;
          if (selectedRows.length > 0) this.selectReady = true;
          else {
            this.selectReady = false;
          }
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled:
              typeof _.find(this.products, {
                id: record[this.columns[0]["dataIndex"]],
              }) == "undefined" &&
              typeof _.find(this.products, {
                reference: record[this.columns[0]["dataIndex"]],
              }) == "undefined",
            name: record.name,
          },
        }),
      };
    },
    columns: function() {
      var keys = _.keys(this.tickets[0]);
      var columns = [],
        x = 0;
      keys.forEach(function(col) {
        if (x == 0)
          columns.push({
            id: x,
            dataIndex: col,
            title: () => {
              return "ID";
            },
          });
        else
          columns.push({
            id: x,
            dataIndex: col,
            title: col,
            selectedMapper: {
              value: null,
              traductable: false,
              lang: null,
              underscore: null,
            },
          });
        x++;
      });
      return columns;
    },
    // mappfunction() {
    //   var keys = _.keys(this.products[0]);
    //   console.log(keys);
    //   return keys;
    // },
    rowKey: function() {
      var keys = _.keys(this.tickets[0]);
      return keys[0];
    },
    waitPercent: function() {
      var percent = (this.waitUpload / this.waitMaxUpload) * 100;
      return percent.toFixed(0);
    },
    uploadProductsReady: function() {
      var num = _.filter(this.uploadProducts, { check: { all: true } });
      // console.log(num);
      return num.length;
    },
    uploadProducts: function() {
      var thos = this;
      var formatedProducts = [];
      // console.log(this.tickets);
      _.forEach(this.tickets, function(value, key) {
        if (key > 0 && value.length > 0) {
          var np = JSON.parse(JSON.stringify(thos.productStructure));
          //info
          np.width["_"] = parseFloat(value[5]);
          np.height["_"] = parseFloat(value[6]);
          np.depth["_"] = parseFloat(value[7]);
          np.weight["_"] = parseFloat(value[8]);
          np.price["_"] = parseFloat(value[2]);
          np.wholesale_price["_"] = parseFloat(value[3]);
          if (
            !isNumber(np.width["_"]) ||
            !isNumber(np.height["_"]) ||
            !isNumber(np.weight["_"]) ||
            !isNumber(np.price["_"]) ||
            !isNumber(np.wholesale_price["_"])
          )
            np.check.info = false;
          //info textuel
          np.condition["_"] = value[25];
          np.meta_description.language[0]["_"] = value[26];
          np.meta_keywords.language[0]["_"] = value[27];
          np.meta_title.language[0]["_"] = value[28];
          if (typeof value[12] != "undefined")
            np.name.language[0]["_"] = value[12].trim();
          np.description_short.language[0]["_"] = value[13];
          if (typeof value[12] != "undefined")
            np.link_rewrite.language[0]["_"] = thos.str2url(value[12].trim());

          if (
            !_.isString(np.condition["_"]) ||
            !_.isString(np.name.language[0]["_"])
          )
            np.check.info = false;

          //supplier
          //on verifie si il existe
          var verifS = _.filter(thos.suppliers, { id: value[1] });
          if (verifS.length > 0) {
            np.id_supplier["_"] = value[1];
            var sp = JSON.parse(JSON.stringify(thos.supplierStructure));
            sp.id_supplier = value[1];
            np.step5.push(sp);
          } else np.check.supplier = false;

          //reference
          //on verifie si unique
          var verifR = _.find(thos.products, { reference: value[0] });
          if (verifR != undefined) np.check.uniq = false;

          np.reference["_"] = value[0];

          //categories
          //on verifie si elles existent
          // console.log(value[19]);
          var npCat = value[19].split(",");
          _.forEach(npCat, function(catValue) {
            var verifC = _.filter(thos.categoriesList, { id: catValue });
            if (verifC.length == 0) np.check.categories = false;
            else {
              //xml.associations.categories.category.push( { id : { '_' : cat}});
              var verif2 = _.filter(np.step2, { id: { _: catValue } });
              if (verif2.length == 0) np.step2.push({ id: { _: catValue } });
            }

            var verifC2 = _.filter(thos.categoriesList, { id: value[18] });
            if (verifC2.length == 0) np.check.categories = false;
            else np.id_category_default["_"] = value[18];

            //addCatStructure
          });

          //features
          //on verifie si elles existent
          var f18 = thos.verifFeatures("18", value[9], true);
          if (_.isObject(f18)) np.step3.push(f18);
          else {
            np.check.features = false;
            np.check.featuresResfused.push(value[9]);
          }

          var f10 = thos.verifFeatures("10", value[10], true);
          if (_.isObject(f10)) np.step3.push(f10);
          else {
            (np.check.features = false),
              np.check.featuresResfused.push(value[10]);
          }

          var f11 = thos.verifFeatures("11", value[11], true);
          if (_.isObject(f11)) np.step3.push(f11);
          else {
            (np.check.features = false),
              np.check.featuresResfused.push(value[11]);
          }

          var f24 = thos.verifFeatures("24", value[14], true);
          if (_.isObject(f24)) np.step3.push(f24);
          else {
            (np.check.features = false),
              np.check.featuresResfused.push(value[14]);
          }

          var f26 = thos.verifFeatures("26", value[15], false);
          if (_.isObject(f26)) np.step3.push(f26);
          // else {
          //   (np.check.features = false),
          //     np.check.featuresResfused.push(value[15]);
          // }

          var f27 = thos.verifFeatures("27", value[16], false);
          if (_.isObject(f27)) np.step3.push(f27);
          // else {
          //   (np.check.features = false),
          //     np.check.featuresResfused.push(value[16]);
          // }

          var f14 = thos.verifFeatures("14", value[20], true);
          if (_.isObject(f14)) np.step3.push(f14);
          else {
            (np.check.features = false),
              np.check.featuresResfused.push(value[20]);
          }

          var f16 = thos.verifFeatures("16", value[21], true);
          if (_.isObject(f16)) np.step3.push(f16);
          else {
            (np.check.features = false),
              np.check.featuresResfused.push(value[21]);
          }

          var f15 = thos.verifFeatures("15", value[22], true);
          if (_.isObject(f15)) np.step3.push(f15);
          else {
            (np.check.features = false),
              np.check.featuresResfused.push(value[22]);
          }

          var f17 = thos.verifFeatures("17", value[23], true);
          if (_.isObject(f17)) np.step3.push(f17);
          else {
            (np.check.features = false),
              np.check.featuresResfused.push(value[23]);
          }

          var f20 = thos.verifFeatures("20", value[24], true);
          if (_.isObject(f20)) np.step3.push(f20);
          else {
            (np.check.features = false),
              np.check.featuresResfused.push(value[24]);
          }

          var priceRange = "";
          if (np.price["_"] < 400) priceRange = "0 - 400€";
          else if (np.price["_"] < 600) priceRange = "400€ - 600€";
          else if (np.price["_"] < 800) priceRange = "600€ - 800€";
          else priceRange = "sup à 800€";

          //a modifier en prod par 28
          var f28 = thos.verifFeatures("28", priceRange, true);
          if (_.isObject(f28)) np.step3.push(f28);

          //check width
          var widthRange = "";
          if (np.width["_"] < 150) widthRange = "Inférieur à 150cm";
          else if (np.width["_"] < 200) widthRange = "150cm - 200cm";
          else if (np.width["_"] < 250) widthRange = "200cm - 250cm";
          else if (np.width["_"] < 300) widthRange = "250cm - 300cm";
          else widthRange = "Supérieur à 300cm";

          //a modifier en prod par 29
          var f29 = thos.verifFeatures("29", widthRange, true);
          if (_.isObject(f29)) np.step3.push(f29);

          //step4
          //Stock
          np.step4 = { stock: parseFloat(value[4]) };
          if (!isNumber(np.step4.stock)) np.check.stock = false;

          if (typeof value[29] == "undefined") np.check.photos = "wait";
          else {
            if (typeof value[29]["verif"] != "undefined") {
              np.check.photos = value[29]["verif"];
              np.step1 = {
                cat: value[29]["cat"],
                others: value[29]["others"],
              };
            }
          }

          if (typeof value[30] == "undefined") np.check.traduction = "wait";
          else {
            if (typeof value[30] != "undefined") {
              var traductions = value[30];
              np.name.language[1]["_"] = traductions[0];
              np.description_short.language[1]["_"] = traductions[1];
              np.meta_description.language[1]["_"] = traductions[2];
              np.meta_keywords.language[1]["_"] = traductions[3];
              np.meta_title.language[1]["_"] = traductions[4];
              np.link_rewrite.language[1]["_"] = thos.str2url(traductions[0]);
              np.check.traduction = true;
            }
          }

          //on verifie les check
          if (
            np.check.uniq &&
            np.check.supplier &&
            np.check.info &&
            np.check.categories &&
            np.check.features &&
            np.check.stock &&
            np.check.photos
          )
            np.check.all = true;

          if (np.check.photos == "wait") np.check.all = false;
          if (np.check.traduction == "wait") np.check.all = false;

          if (typeof value[31] == "undefined") {
            if (np.check.all) np.check.upload = "wait";
            else np.check.upload = false;
          } else {
            np.check.upload = value[31];
          }

          np.checkA = Object.entries(np.check);

          formatedProducts.push(np);
        }
      });
      return formatedProducts;
    },
  },
  mounted() {
    let xlsxScript = document.createElement("script");
    xlsxScript.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.8.0/xlsx.full.min.js"
    );
    document.head.appendChild(xlsxScript);
  },
  methods: {
    verifFeatures(idF, value, required) {
      if (typeof value == "undefined") {
        if (required) {
          return false;
        } else {
          return true;
        }
      } else {
        var lodash = _.filter(this.featuresList, function(x) {
          if (x.id_feature["_"] != idF) return false;
          var S = _.filter(x.value.language, function(v) {
            return v["_"].toUpperCase().trim() == value.toUpperCase().trim();
          });
          if (S.length > 0) return true;
          else return false;
        });
        if (lodash.length > 0) {
          //return lodash[0]["id"];
          return {
            attr: {
              "xlink:href":
                "https://www.tribaliste.com/api/product_features/" + idF,
            },
            id: idF,
            id_feature_value: {
              _: lodash[0]["id"],
              attr: {
                "xlink:href":
                  "https://www.tribaliste.com/api/product_feature_values/" +
                  lodash[0]["id"],
              },
            },
          };
        } else return false;
      }
      //var verifC = _.filter(this.featuresList, { id: catValue });
      //if (verifC.length == 0) np.check.categories = false;
    },
    str2url(aStr) {
      // converti le texte en minuscule
      var s = aStr.toLowerCase();
      // remplace les a accentué
      s = s.replace(/[àâäáã]/g, "a");
      // remplace les e accentué
      s = s.replace(/[èêëé]/g, "e");
      // remplace les i accentué
      s = s.replace(/[ìîïí]/g, "i");
      // remplace les u accentué
      s = s.replace(/[ùûüú]/g, "u");
      // remplace les o accentué
      s = s.replace(/[òôöó]/g, "o");
      // remplace le c cédille
      s = s.replace(/[ç]/g, "c");
      // remplace le ene tilde espagnol
      s = s.replace(/[ñ]/g, "n");
      // remplace tous les caractères qui ne sont pas alphanumérique en tiret
      s = s.replace(/\W/g, "-");
      // remplace les double tirets en tiret unique
      s = s.replace(/-+/g, "-");
      // renvoi le texte modifié
      return s;
    },
    tableRowClassName(row) {
      if (
        typeof _.find(this.products, { id: row[this.columns[0]] }) ==
        "undefined"
      ) {
        return "inactive-row";
      }
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files,
        thos,
        i,
        f;
      thos = this;
      for (i = 0, f = files[i]; i != files.length; ++i) {
        var reader = new FileReader();
        reader.onload = function(e) {
          var results,
            data = e.target.result,
            fixedData = fixdata(data),
            workbook = window.XLSX.read(btoa(fixedData), { type: "base64" }),
            firstSheetName = workbook.SheetNames[0],
            worksheet = workbook.Sheets[firstSheetName];
          thos.headers = get_header_row(worksheet);
          results = window.XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          // console.log(results);
          thos.tickets = _.filter(results, function(o) {
            return o.length > 0;
          });
          console.log(thos.userToken);
          axios
            .post(
              process.env.VUE_APP_APIURL + "/images/multiple",
              {
                images: results,
              },
              {
                headers: {
                  Authorization: `Bearer ${thos.userToken}`,
                },
              }
            )
            .then((response) => response.data)
            .then((items) => {
              // console.log(items);
              thos.waitMax = items.max;
              thos.sockets.subscribe(items.socket, (data) => {
                thos.waitActual = data.num;
                var key = _.findIndex(thos.tickets, function(o) {
                  return o[0] == data.id;
                });

                if (key > -1) {
                  var newTicket = _.clone(thos.tickets);
                  newTicket[key][29] = {
                    cat: data.cat,
                    others: data.others,
                    verif: data.result,
                  };
                  thos.tickets = newTicket;
                }
              });
            });

          axios
            .post(
              process.env.VUE_APP_APIURL + "/upload/traduction",
              {
                data: results,
              },
              {
                headers: {
                  Authorization: `Bearer ${thos.userToken}`,
                },
              }
            )
            .then((response) => response.data)
            .then((items) => {
              items.forEach(function(item) {
                console.log(item);
                var key = _.findIndex(thos.tickets, function(o) {
                  return o[0] == item.id;
                });

                if (key > -1) {
                  var newTicket = _.clone(thos.tickets);
                  newTicket[key][30] = item.trad;
                  thos.tickets = newTicket;
                }
              });
            });
        };
        reader.readAsArrayBuffer(f);
      }
    },
    handleChange(e, o) {
      this.mapper[o.data.attrs.index] = e;
      this.columns[o.data.attrs.index].selectedMapper.value = e;
      this.columns[o.data.attrs.index].selectedMapper.traductable = _.filter(
        this.mappValue,
        {
          title: e,
        }
      )[0]["trad"];
      this.columns[o.data.attrs.index].selectedMapper.underscore = _.filter(
        this.mappValue,
        {
          title: e,
        }
      )[0]["underscore"];
      if (
        _.filter(this.columns, { selectedMapper: { value: null } }).length == 0
      )
        this.mapperReady = true;
    },
    handleChangeLang(e, o) {
      this.columns[o.data.attrs.index].selectedMapper.lang = e;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    massUpload() {
      var key = "massEdit";
      this.$message.loading({
        content: "Ajout En Masse ...",
        key: key,
      });
      this.waitServer = true;
      var data = _.filter(this.uploadProducts, { check: { all: true } });
      // console.log(data);
      axios
        .post(
          process.env.VUE_APP_APIURL + "/upload/multiple",
          {
            data: data,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          }
        )
        .then((response) => response.data)
        .then((items) => {
          // console.log(items);
          this.waitMaxUpload = items.max;
          this.sockets.subscribe(items.socket, (data) => {
            this.waitUpload = data.num;
            // console.log(data);
            if ("id" in data) {
              var key = _.findIndex(this.tickets, function(o) {
                return o[0] == data.id;
              });

              if (key > -1) {
                var newTicket = _.clone(this.tickets);
                if (data.result) newTicket[key][31] = "uploaded";
                else newTicket[key][31] = "error";

                this.tickets = newTicket;
              }
            }

            if (this.waitUpload == this.waitMax)
              this.sockets.unsubscribe(data.socket);
            //this.$store.dispatch("flushCache");
          });
        });
    },
  },
};
</script>

<style lang="scss">
#productsMassEdit {
  width: 90%;

  .steps {
    margin: 25px;
  }
  .tableData {
    margin: 25px 0;
  }

  .inactive-row {
    background-color: rgba(215, 44, 44, 0.2);
  }
}
#drop {
  width: 100%;
  border: 2px dashed #bbb;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  padding: 25px;
  text-align: center;
  font: 20pt bold, "Vollkorn";
  color: #bbb;
}
</style>
